import {useState} from 'react';
import {Link} from 'react-router-dom';
import {BookOpen, Search, LockKeyhole} from 'lucide-react';
import {PageIntro, Action, Loading} from '../components/Common';
import {Input} from '../components/ui/input';
import {PublicDataError} from '../components/PublicDataState';
import {usePublicCollection} from '../hooks/usePublicCollection';
import {Conversation} from './Home';

export default function Book() {
  const {data: books, loading, error, reload} = usePublicCollection('/books');
  const [search, setSearch] = useState('');
  const filtered = (books || []).filter(book =>
    `${book.title} ${book.part} ${book.category}`.toLowerCase().includes(search.trim().toLowerCase())
  );
  return <>
    <PageIntro id="book" eyebrow="THE INSTITUTIONAL LIBRARY / 45 CONNECTED VOLUMES"
      title={<>A body of thought.<br/><em>A foundation for action.</em></>}
      description="The Mahakali Tribunal Master Book: a connected framework for our business, products and operating principles."/>
    <section className="wrap book-library" aria-busy={loading}>
      <div className="library-intro">
        <BookOpen strokeWidth={1.3} size={28}/>
        <p data-testid="book-intro">Explore the library index. Full source documents are reviewed individually before release to approved investors.</p>
        <Action to="/login" secondary id="book-access">Investor access</Action>
      </div>
      <div className="search-box">
        <Search size={18}/>
        <Input placeholder="Search volumes, topics or part numbers…" aria-label="Search book volumes"
          value={search} onChange={event => setSearch(event.target.value)}
          disabled={!books || loading} data-testid="book-search"/>
      </div>
      {loading ? <Loading/> : error ?
        <PublicDataError id="book" label="The library" error={error} onRetry={reload}/> : <>
          <div className="caption library-count" data-testid="book-count">{filtered.length} of {books.length} volumes</div>
          <div className="library-grid">
            {filtered.map(book => <Link to="/investor-relations" key={book.id} className="volume" data-testid={`volume-${book.part}`}>
              <span className="volume-number">{String(book.part).padStart(2, '0')}</span>
              <div><span className="caption">{book.category}</span>
                <h3 data-testid={`volume-title-${book.part}`}>{book.title}</h3>
                <span className="caption">{book.pages} pages · PDF source</span>
              </div><LockKeyhole size={15}/>
            </Link>)}
          </div>
          {!filtered.length && <p data-testid="book-no-results" className="empty">
            {search.trim() ? 'No volumes match your search.' : 'The library index is being prepared. Please check again shortly.'}
          </p>}
        </>}
    </section><Conversation/>
  </>;
}